/* eslint-disable camelcase */
import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
    UIParagraph,
} from 'app/components/ui';
import { AuthContext } from 'app/containers/AuthContainer';
import { isDesktop } from 'app/utils/resolution';
import { LocationContext } from 'app/containers/LocationProvider';
import { boxPages } from 'global/const/pagesCategories/boxes';

import { BasketCheckPrice } from '../BasketCheckRows/BasketCheckPrice';
import { BasketCheckPromocodeForm } from '../BasketCheckRows/BasketCheckPromocodeForm';
import { BasketCheckGetDiscount } from '../../BasketCheckGetDiscount/BasketCheckGetDiscount';

import s from './basket-receipt-landing.scss';

/* COMPONENTS  */

function BasketReceiptPromocode(props) {
    const {
        promocodeConditions,
        promocode,
        applyPromocodeHandler,
        hasSubmitBtn = false,
    } = props;

    const applyPromocode = useCallback((nextPromocode) => {
        // TODO: use external sourceName
        const sourceName = 'trial_check';
        return applyPromocodeHandler({ nextPromocode, sourceName });
    }, [applyPromocodeHandler]);

    const heightType = isDesktop() ? 'large' : 'medium';

    return (
        <div className={s['trial-check-row__promocode']}>
            <BasketCheckPromocodeForm
                heightType={heightType}
                promocode={promocode}
                discountConditions={promocodeConditions}
                applyPromocodeHandler={applyPromocode}
                hasSubmitBtn={hasSubmitBtn}
                isBoxPage
            />
        </div>
    );
}

BasketReceiptPromocode.propTypes = {
    promocodeConditions: PropTypes.shape({}).isRequired,
    promocode: PropTypes.string.isRequired,
    applyPromocodeHandler: PropTypes.func.isRequired,
    hasSubmitBtn: PropTypes.bool,
};


function BasketReceiptDiscount(props) {
    const {
        promocodeFromUrl,
        isWelcomeDiscountShown,
        handleOpenAuthDiscount,
    } = props;

    const { userData } = useContext(AuthContext);
    const user = userData?.user || null;

    const isNewUser = user
        ? (user.deliveries.length === 0 && user.successDeliveriesCount === 0)
        : true;
    const isWelcomeDiscountHidden = promocodeFromUrl || !isNewUser;

    if (isWelcomeDiscountHidden) return null;

    return (
        <BasketCheckGetDiscount
            env="trial-check"
            handleOpenAuthDiscount={handleOpenAuthDiscount}
            isWelcomeDiscountShown={isWelcomeDiscountShown}
        />
    );
}

BasketReceiptDiscount.propTypes = {
    promocodeFromUrl: PropTypes.string.isRequired,
    isWelcomeDiscountShown: PropTypes.bool.isRequired,
    handleOpenAuthDiscount: PropTypes.func.isRequired,
};


const noop = () => { };

export function BasketReceiptLanding({
    dishesPrice,
    deliveryPrice,
    promocodeAmount,
    totalCommonPrice,
    pageId = '',
    promocode = '',
    promocodeConditions,
    applyPromocodeHandler,

    promocodeFromUrl = '',
    handleOpenAuthDiscount = noop,
    isWelcomeDiscountShown,
    hasSubmitBtn = false,
    isPromocodeShown = true,
}) {
    // const { country_subdivision } = useContext(LocationContext);
    const zeroReplacer = totalCommonPrice === 0 ? '-' : null;

    // const regionTitle = getLocationTitle(country_subdivision);

    const isBoxPage = boxPages.includes(pageId);
    const rootClasses = classNames({
        [s['trial-check-root']]: true,
        [s.boxes]: isBoxPage,
    });

    const isMarchgiftsPage = window.location?.pathname?.includes('marchgifts');

    return (
        <div className={rootClasses}>
            <div className={s['trial-check-row']}>
                <div className={s['trial-check-row--flex']}>
                    <UIParagraph level="4.2">
                        <span className={s['basket-check-row__text']}>
                            Стоимость блюд
                        </span>
                    </UIParagraph>
                    <BasketCheckPrice price={dishesPrice} zeroReplacer={zeroReplacer} />
                </div>
            </div>
            <div className={s['trial-check-row']}>
                <div className={s['trial-check-row--flex']}>
                    <UIParagraph level="4.2">
                        <span className={s['basket-check-row__text']}>
                            Доставка
                            {/* &nbsp;
                            {regionTitle} */}
                        </span>
                    </UIParagraph>
                    <BasketCheckPrice price={deliveryPrice} zeroReplacer={zeroReplacer} />
                </div>
            </div>
            {!isMarchgiftsPage && (
                <div className={s['trial-check-row']}>
                    <div className={s['trial-check-row--flex']}>
                        <UIParagraph level="4.2">
                            <span className={s['basket-check-row__text']}>
                                Промокод
                            </span>
                        </UIParagraph>
                        <BasketCheckPrice
                            price={promocodeAmount}
                            zeroReplacer={zeroReplacer}
                        />
                    </div>
                    {isPromocodeShown && (
                        <BasketReceiptPromocode
                            promocode={promocode}
                            promocodeConditions={promocodeConditions}
                            applyPromocodeHandler={applyPromocodeHandler}
                            hasSubmitBtn={hasSubmitBtn}
                        />
                    )}
                    <BasketReceiptDiscount
                        promocodeFromUrl={promocodeFromUrl}
                        handleOpenAuthDiscount={handleOpenAuthDiscount}
                        isWelcomeDiscountShown={isWelcomeDiscountShown}
                    />
                </div>
            )}
            <div className={`${s['trial-check-row']} ${s['trial-check-row--flex']}`}>
                <div>
                    <span className={s['trial-check-row__H3-2']}>
                        ИТОГО
                    </span>
                </div>
                <BasketCheckPrice
                    price={totalCommonPrice}
                    zeroReplacer={zeroReplacer}
                    type="total"
                />
            </div>
        </div>
    );
}

BasketReceiptLanding.propTypes = {
    dishesPrice: PropTypes.number.isRequired,
    deliveryPrice: PropTypes.number.isRequired,
    promocodeAmount: PropTypes.number.isRequired,
    totalCommonPrice: PropTypes.number.isRequired,

    promocode: PropTypes.string,
    promocodeConditions: PropTypes.shape({}).isRequired,
    applyPromocodeHandler: PropTypes.func.isRequired,

    promocodeFromUrl: PropTypes.string,
    handleOpenAuthDiscount: PropTypes.func,
    isWelcomeDiscountShown: PropTypes.bool.isRequired,
    pageId: PropTypes.string,
    hasSubmitBtn: PropTypes.bool,
};
